import AudioPlayerPlaylistItem from 'crowdaa-ux/components/AudioPlayerPlaylistItem';
import CrowdaaAPI from 'crowdaa-api';
import ErrorMessage from 'crowdaa-ux/components/ErrorMessage';
import OverlayLogin from 'crowdaa-ux/components/OverlayLogin';
import OverlayShare from 'crowdaa-ux/components/OverlayShare';
import Playlist from 'crowdaa-ux/components/Playlist';
import PropTypes from 'prop-types';
import React from 'react';
import SharingButtons from 'crowdaa-ux/components/SharingButtons';
import SimpleBar from 'simplebar-react';
import SliderMenu from 'crowdaa-ux/components/SliderMenu';
import faBars from '@fortawesome/fontawesome-free-solid/faBars';
import faShareAlt from '@fortawesome/fontawesome-free-solid/faShareAlt';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import shuffle from 'lodash/shuffle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-refetch';
import { intlShape } from 'react-intl';
import Loading from '../components/Loading';
import 'simplebar/dist/simplebar.min.css';
import './PlaylistPage.scss';
import '../components/video-react.css'; // import css
import PlayerVideo from '../components/PlayerVideo';


class PlaylistPage extends React.PureComponent {
  static propTypes = {
    autoplay: PropTypes.bool,
    selectionFetch: PropTypes.object.isRequired,
    videos: PropTypes.object.isRequired,
    selectionId: PropTypes.string.isRequired,
    trackId: PropTypes.string,
    url: PropTypes.string,
    isMobile: PropTypes.bool,
  };

  static contextTypes = {
    apiURL: PropTypes.string,
    intl: intlShape,
    loginToken: PropTypes.string,
    userId: PropTypes.string,
  };

  static defaultProps = {
    autoplay: false,
    trackId: null,
    url: null,
    isMobile: true,
  };

  constructor(props) {
    super(props);
    this.handleMediaSelected = this.handleMediaSelected.bind(this);

    this.state = {
      selectedId: null,
      displayShare: false,
      displayConnect: false,
      displayMenu: false,
      isTimerRuning: false,
      timerKey: null,
      currentContent: null,

    };
  }

  componentDidMount() {
    if (!this.state.isTimerRuning) {
      const timerKey = setInterval(this.checkTime, 1000);
      this.setState({ isTimerRuning: true, timerKey });
    }
  }

  handleStateChange = (state) => {
    // copy player state to this component's state
    this.setState({
      player: state,
      currentTime: state.currentTime,
      video: state.video,
      isActive: state.isActive,
    });
    //    this.props.getCurrentTime(state.currentTime);
  }

  checkTime = () => {
    if (this.state.currentContent !== null
      && this.state.currentTime > this.state.currentContent.timerThreshold
      && !this.context.userId) {
      clearInterval(this.state.timerKey);
      this.setState({ displayConnect: true, timerKey: null, isTimerRuning: false });
    } else {
      this.setState({ displayConnect: false });
    }
  }

  getCurrentTime = (currentTime) => {
    this.setState({ currentTime });
  }

  handleMediaSelected(_id) {
    if (_id !== this.state.selectedId && !this.context.userId) {
      const timerKey = setInterval(this.checkTime, 1000);
      this.setState({ isTimerRuning: true, timerKey });
    }

    const { videos } = this.props.selectionFetch.value;
    const content = find(videos, ['_id', _id]);
    this.setState({
      selectedId: _id,
      currentContent: content,
    });
  }

  onCloseOverlay = () => {
    this.setState({ displayConnect: false });
    // go to next content
    this.getNextContent();
  }

  getNextContent = () => {
    const { videos } = this.props.selectionFetch.value;
    let index = findIndex(videos, ['_id', this.state.selectedId]);
    if (index === videos.length - 1) {
      index = 0;
    } else {
      index += 1;
    }
    const content = videos[index];
    this.setState({
      selectedId: content._id,
      currentContent: content,
    });
    this.handleMediaSelected(content._id);
  }

  handleVideoEnded = () => {
    const { videos } = this.props.selectionFetch.value;
    let playingId = this.state.selectedId || videos[0]._id;
    const currentIndex = findIndex(videos, { _id: playingId });
    playingId = videos[(currentIndex + 1) % videos.length]._id;
    this.setState({ selectedId: playingId });
  };

  handleVideoPrev = () => {
    const { videos } = this.props.selectionFetch.value;
    let playingId = this.state.selectedId || videos[0]._id;
    const currentIndex = findIndex(videos, { _id: playingId });
    playingId = videos[(currentIndex + videos.length - 1) % videos.length]._id;
    this.setState({ selectedId: playingId });
  };

  handleShareBtn = () => {
    this.setState({ displayShare: !this.state.displayShare });
  }

  handleMenuBtn = () => {
    this.setState({ displayMenu: !this.state.displayMenu });
  }

  handleOverlayClose = () => {
    this.setState({ displayConnect: false });
  }

  handleTimer = () => {
    this.setState({ displayConnect: true });
    this.handleAudioEnded();
  }

  render() {
    const { formatMessage } = this.context.intl;
    const { userId } = this.context;
    const {
      selectionFetch, trackId, url, autoplay, selectionId, isMobile,
    } = this.props;
    const {
      selectedId, displayShare, displayConnect, displayMenu,
    } = this.state;

    const sharingUrl = encodeURIComponent(
      `${process.env.REACT_APP_SSR_URL}/selections/${selectionId}?redirect_url=${url}&appName=${process.env.REACT_APP_NAME}`,
    );

    if (selectionFetch.pending) return <Loading url="https://trace.tv/wp-content/uploads/2016/11/logo_africa1.png" />;
    if (selectionFetch.rejected) { return <ErrorMessage error={selectionFetch.reason} />; }
    if (selectionFetch.value) {
      const { videos, selectionDisplayName } = selectionFetch.value;
      if (!videos || !videos.length) {
        return (
          <ErrorMessage
            error={new Error(formatMessage({ id: 'no_video_here' }))}
          />
        );
      }
      const idToPlay = selectedId || trackId || videos[0]._id;
      const video = find(videos, t => t._id === idToPlay);
      this.setState({ currentContent: video });
      const cover = video.projectThumbFileUrl;
      const {
        title, author, singer, hlsUrl,
      } = video;
      return (
        <div className="crowdaa_player_container">
          <div
            className="bg-image"
            style={{ backgroundImage: `url('${cover}')` }}
          />
          <div>
            <div className={`player ${displayShare ? 'active-background' : ''}`}>
              <div
                className='cover'
                style={{
                  borderBottom: 'solid 1px gray',
                  backgroundImage: `linear-gradient(rgba(26, 27, 30, 1), rgba(26, 27, 30, 1))${displayShare ? '' : `, url('${cover}')`}`,
                }}
              >
                <nav>
                  <div className="left">
                    <FontAwesomeIcon icon={faBars} size="1x" onClick={this.handleMenuBtn} />
                    <h6>{selectionDisplayName}</h6>
                  </div>
                  <div className="right">
                    <FontAwesomeIcon
                      icon={displayShare ? faTimes : faShareAlt}
                      onClick={this.handleShareBtn}
                    />
                  </div>
                </nav>
                <SharingButtons
                  title={`${author || singer} - ${title}`}
                  sharingUrl={sharingUrl}
                  className={displayShare ? '' : 'd-none'}
                />
                <SliderMenu className={displayMenu ? '' : 'd-none'} onClose={this.handleMenuBtn} />

                <PlayerVideo
                  selectedId={selectedId}
                  video={this.state.currentContent}
                  autoplay={autoplay}
                  muted
                  poster={cover}
                  src={hlsUrl}
                  onCloseOverlay={this.onCloseOverlay}
                  getCurrentTime={this.getCurrentTime}
                  displayConnect={displayConnect}
                  displayShare={false}
                  isMobile={isMobile} />
              </div>
              <SimpleBar className="music">
                {
                  displayConnect && !userId && <OverlayLogin onClose={this.handleOverlayClose} />
                }
                {
                  displayConnect && userId && <OverlayShare onClose={this.handleOverlayClose} />
                }
                {
                  !displayConnect && <Playlist
                    ItemComponent={AudioPlayerPlaylistItem}
                    media={videos}
                    onSelect={this.handleMediaSelected}
                    selectedId={idToPlay}
                  />
                }
              </SimpleBar>
            </div>
          </div>
        </div>
      );
    }
    return <Loading />;
  }
}

export default connect.defaults(
  new CrowdaaAPI({ type: '', duration: 5 * 60000 }),
)((props, context) => {
  const { apiURL } = context;
  const { selectionId } = props;
  return {
    selectionFetch: {
      context,
      url: `${apiURL}/selections/${selectionId}`,
      then: (selection) => {
        const value = selection;
        value.randomTracks = shuffle(value.tracks);
        const tmp = [];
        value.tracks.forEach((element) => {
          if (element.collection === 'video') {
            tmp.push(element);
          }
        });
        value.videos = tmp;
        return { value };
      },
    },
  };
})(PlaylistPage);
